// @flow strict

import React, { type Node, Fragment } from 'react';
import { Container } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { SEO, type SEOFields } from './seo';
import { Header } from './header/header';
import { Footer } from './footer/footer';
import { Navigation } from '~components/layout/navigation/navigation';

import type { Alternates } from '~types/post';

/**
 * Type of component properties
 */
type LayoutProps = {
  alternates: Alternates,
  seoFields: SEOFields,
  subscribeUrl?: string,
  children: Node,
};

/**
 * Default layout of page.
 *
 * Adds header, footer, and SEO component, and
 * inserts content into main section.
 *
 * @param {LayoutProps} props - component properties
 *
 * @returns {Node}
 */

export const Layout = ({
  alternates,
  seoFields,
  subscribeUrl,
  children,
}: LayoutProps) => {
  return (
    <Fragment>
      <Helmet>
        <link
          rel="preload"
          href="/css/font.css"
          as="style"
          onLoad="this.onload=null;this.rel='stylesheet'"
        />
      </Helmet>
      <Navigation />
      <Container fixed>
        <SEO fields={seoFields} />
        <Header
          alternates={alternates}
          showWebsiteNavigationItemsOnMobileOnly={false}
        />
        <main>{children}</main>
      </Container>
      <Footer />
    </Fragment>
  );
};
